import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { jwtDecode } from 'jwt-decode';

import * as AuthActions from '../shared-store/auth/auth.actions';
import { selectIsAuthenticated } from '../shared-store/auth/auth.selectors';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  private readonly STORAGE_KEY = 'savedTargetUrl';

  redirectRoute: string = '/owner-dashboard';
  badCredentials = false;

  constructor(private router: Router, private store: Store) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(selectIsAuthenticated).pipe(
      take(1),
      map((ok) => {
        if (ok) return true;

        localStorage.setItem(this.STORAGE_KEY, state.url);
        this.router.navigate(['/'], { queryParams: { redirect: state.url } });
        return false;
      })
    );
  }

  redirectCallback(credentialType: string) {
    if (credentialType === 'PetszelConnectClient') {
      const target = localStorage.getItem(this.STORAGE_KEY) ?? this.redirectRoute;
      localStorage.removeItem(this.STORAGE_KEY);

      localStorage.setItem('token', 'placeholder');

      this.badCredentials = false;

      this.router.navigateByUrl(target);

    } else {
      this.badCredentials = true;
      localStorage.removeItem('token');
      this.store.dispatch(AuthActions.logout()); 
    }
  }

  isLoggedIn(): boolean {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const decoded = jwtDecode<any>(token);
    const credentialType = decoded['petszel-credentialtype'];
    const roles = Array.isArray(credentialType) ? credentialType : [credentialType];

    const ok = roles.includes('PetszelConnectClient');

    return ok;
  } catch {
    return false;
  }
}

  logoutAndRedirect(): Observable<void> {
    this.store.dispatch(AuthActions.logout());
    return of(undefined);
  }
}
